/* global DISPLAY_DATE_FORMAT */

import PropTypes from 'prop-types'
import React from 'react'
import Rodal from 'rodal'

import 'rodal/lib/rodal.css'
import './styles.css'

function RetentionDialog({
  isMobile,
  cancel,
  subscription,
  open,
  onClose,
  acceptRetentionDiscount,
  isDisabled
}) {
  const onCloseDialog = () => {
    onClose()
  }

  return (
    <Rodal
      visible={open}
      onClose={onCloseDialog}
      width={isMobile ? 335 : 600}
      height={330}
      animation="fade"
      className="confirmation"
    >
      <div className="subscription-section confirmation" id="RetentionDialog">
        <div className="header">
          <h2>Before you go...</h2>
        </div>
        <div className="dialog-content">
          <p>
            Get {subscription?.cancellationDiscountPercentage}% off your current
            plan! No changes. No interruptions. Keep creating!
          </p>
        </div>
        <div className="action-buttons">
          <button
            type="button"
            onClick={() => {
              acceptRetentionDiscount()
            }}
            className="btn -mini -orange"
            disabled={isDisabled}
          >
            {`Stay Subscribed & Save ${subscription?.cancellationDiscountPercentage}%`}
          </button>
          <button
            onClick={() => {
              cancel()
            }}
            className="cancel-anyway-btn"
            type="button"
            disabled={isDisabled}
          >
            Continue to cancel
          </button>
        </div>
      </div>
    </Rodal>
  )
}

RetentionDialog.propTypes = {
  isMobile: PropTypes.bool.isRequired
}

export default RetentionDialog
